export default class Selector {
    constructor(public options: any,
                private useDefault: SelectorDefault = SelectorDefault.None,
                private defaultIsList: boolean = false,
                public nestedControlPrefix: string|null = null,
                private isRequired = false) {
        this.clear();
    }

    public value?: any = [];
    public result?: any = undefined;

    public get defined() {
        return this.value !== undefined &&
               this.value !== '' &&
               this.value.length != 0;
    }

    public get satisfied() {
        return !this.isRequired || this.defined;
    }

    public getResult(): any {
        return this.result !== undefined ? this.result : this.value;
    }

    public clear() {
        switch (this.useDefault) {
            case SelectorDefault.First:
                const def = (this.options instanceof Array) ? this.options[0] : this.options;
                this.value = this.defaultIsList ? [def] : def;
                break;
            case SelectorDefault.All:
                console.log(this.options);
                this.value = this.options;
                break;
            default:
                this.value = this.defaultIsList ? [] : undefined;
                break;
        }
    }
}

export enum SelectorDefault {
    None = 'none',
    First = 'first',
    All = 'all',
}
